import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from './../../../pages/com.usblick.common/auth/user.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModalConfirmComponent } from 'app/shared/material-modal-confirm/material-modal-confirm.component';
import { RestService } from 'app/shared/rest.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { formatDate } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { setting } from '../../../../../setting';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit {

  @Input() clientSetting: any;
  @Input() productId: any
  @Input() payload: any;
  @Input() action: any;
  @Output() closeModal = new EventEmitter<any>();
  @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;
  @ViewChildren('iconsList', { read: ElementRef }) iconsList: QueryList<ElementRef>;

  formCommentVisible: boolean = false;
  agentName: string = '';
  agencyName: string = '';
  filterColorIcon: any;
  commentsForm: FormGroup;
  backgroundAssent: string;
  cardLine: string;
  assesmentComments = Array.from({ length: 5 }, (_, i) => i);
  createCommentAvailable: boolean = true;
  comments: any[] = [];
  commentsAgent: any[] = [];
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  now = new Date();
  editCommentsVisible: boolean = false;
  createCommentsVisible: boolean = false;
  textComplete: boolean = false;
  btnSeeMore:boolean = false;
  bookingApiStorage: string;
clientSettingBody: any;

 colors = [
            '#ff4d4d',  // Rojo intenso (1 - Muy malo)
            '#ff8c66',  // Rojo-naranja (2 - Malo)
            '#ffcc00',  // Amarillo (3 - Regular)
            '#66cc66',  // Verde claro (4 - Bueno)
            '#00b359'   // Verde esmeralda (5 - Excelente)
          ];

  constructor(
              private userService: UserService,
              private formBuilder: FormBuilder,
              private notificationService: NotificationService,
              public dialog: MatDialog,
              private restService: RestService,
             ) {
                this.dpConfig = {
                    dateInputFormat: 'DD-MM-YYYY',
                };
             }

  ngOnInit(): void {
        const clientSettingBody = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body);
        this.clientSettingBody = clientSettingBody;
        this.cardLine = clientSettingBody?.card_line;
        this.backgroundAssent = clientSettingBody?.card_background_price;
        this.bookingApiStorage = setting.apiStorageBooking;

        if(this.action === 'comments') {

          this.getComments();
          this.initCommentForm();
          this.editCommentsVisible = false;
          this.createCommentsVisible = true;
          this.formCommentVisible = true;
        } else {

            this.getComments();
            this.initCommentForm();
            this.applyImageFilter();
        }


        // this.lengthComments();

  }




    initCommentForm(): void {
    this.agentName = `${this.userService._agent?.first_name} ${this.userService._agent?.last_name}`;
    this.agencyName = this.userService?._agencyName;
    this.commentsForm = this.formBuilder.group({
      comments: new FormControl(null, Validators.required),
      title: new FormControl(null, Validators.required),
      assesment: new FormControl(0, Validators.required),
      assent: new FormControl(false),
      reservation_date: new FormControl(null, Validators.required),
      passenger_name: new FormControl(null, Validators.required)
    });

    this.subscribeAssesment();

  }

subscribeAssesment(): void {
  this.commentsForm.get('assesment')?.valueChanges.subscribe((value: any) => {
    this.applyImageFilter();
  });
}

  onSubmitComment(): void {
    const url = this.userService._imagen_logotype;
    const shortUrl = url.split("agencias/")[1];
    const finalUrl = "agencias/" + shortUrl;
    const assent: boolean = this.commentsForm.get('assent').value;
    if(assent && this.commentsForm.valid) {
      const assesment = this.commentsForm.get('assesment')?.value;
      const payload = {
        booking_agent_id: this.userService?._agentID ?? null,
        booking_agent_name: this.agentName ?? null,
        booking_agency_id: this.userService?._agencyID ?? null,
        booking_agency_name: this.userService?._agencyName ?? null,
        title: this.commentsForm.get('title')?.value ?? null,
        comments: this.commentsForm.get('comments')?.value ?? null,
        assesment: assesment ? assesment.toString() : null,
        product_id: this.productId ?? null, //cambiar a hotelId
        category_id: this.payload?.categoriesId[0] ?? null,
        product_table: this.getNameCategory(this.payload?.categoriesId[0]) ?? null,
        client_id: this.clientSetting.id,
        passenger_name: this.commentsForm.get('passenger_name').value ?? null,
        reservation_date: this.commentsForm.get('reservation_date')?.value  ? formatDate(this.commentsForm.get('reservation_date')?.value, 'yyyy-MM-dd', 'en-US') : null,
        assent: true,
        logo: finalUrl
      }
      const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
        data: { message: this.createCommentsVisible ? 'Crear comentario' : 'Editar comentario', type: 'material' },
        width: '360px'
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if(result) {
          if(this.createCommentsVisible) {
            this.restService.doPost('api', '/cruds/comments',payload).subscribe({
              next: (res: any) => {
                if(res.status === 'success') {
                  this.notificationService.success('Su comentario ha sido creado con éxito');
                  this.formCommentVisible = false;
                  this.comments = [];
                  this.commentsAgent = [];
                  if(this.action === 'comments') {
                    this.closeModal.emit();
                  } else {
                      this.createCommentsVisible = !this.createCommentAvailable;
                      this.getComments();
                  }

                }
              },
              error: (error: HttpErrorResponse) => {
                this.notificationService.warning('Ocurrió un error al crear el comentario');
              }
            })
          }
          if(this.editCommentsVisible) {
             const url = `/cruds/comments/${this.commentsAgent[0]?.id}`
             this.restService.doPut('api', url ,payload).subscribe({
              next: (res: any) => {
                if(res.status === 'success') {
                  this.notificationService.success('Su comentario ha sido editado con éxito');
                  this.formCommentVisible = false;
                  this.editCommentsVisible = !this.editCommentsVisible;
                  this.comments = [];
                  this.commentsAgent = [];
                  this.getComments();
                }
              },
              error: (error: HttpErrorResponse) => {
                this.notificationService.warning('Ocurrió un error al crear el comentario');
              }
            })
          }

          } else {
            return;
          }
      })
    } else {

      if(!assent) {
        this.notificationService.info('Acepte los terminos de creación de comentario');
      }

      if(!this.commentsForm.valid) {
        this.commentsForm.markAllAsTouched();
      }

    }



  }

  getNameCategory(categoryId: any): string {

    switch (categoryId) {
      case 1:
        return 'Hotels';
      case 2:
        return 'Rent-a-car'
      case 8:
        return 'Transfer';
      case 6:
        return 'Experience';
      case 9:
        return 'Tickets';
      case 10:
        return 'Insurance';
      break
    }
  }

      applyImageFilter() {
        setTimeout(() => {
          const assesmentValue = this.commentsForm.get('assesment').value;


          this.icons.forEach((icon, index: number) => {
            if (index < assesmentValue) {
              const color = this.colors[assesmentValue - 1]; // Selecciona el color según la valoración
              icon.nativeElement.setAttribute(
                'style',
                `background-color: ${color};
                width: 40px;
                border-radius: 50%;
                height: 40px;
                position: absolute;
                left: 13%;
                top: 8%;
                z-index: 1;
                transition: background-color 0.3s ease;` // Agrega transición suave
              );
            } else {
              icon.nativeElement.removeAttribute('style');
            }
          });
        }, 100);
      }


        addComments(): void {
          this.commentsForm.reset();
          this.createCommentsVisible = !this.createCommentsVisible;

          this.formCommentVisible = !this.formCommentVisible;
        }

        getCommentadjective(adjetive: number): string {
          switch(adjetive) {
            case 0: return 'SIN CALIFICAR';
            case 1: return 'MALO';
            case 2: return 'REGULAR';
            case 3: return 'BUENO';
            case 4: return 'MUY BUENO';
            case 5: return 'EXCELENTE';
          }
        }


          getIconsComments(index: number): string {

            switch(index) {
              case 0:
                return '../../../../assets/icons/comments-assesment/MALO.svg';
              case 1:
                return '../../../../assets/icons/comments-assesment/REGULAR.svg';
              case 2:
                return '../../../../assets/icons/comments-assesment/BUENO.svg';
              case 3:
                return '../../../../assets/icons/comments-assesment/MUYBUENO.svg';
              case 4:
                return '../../../../assets/icons/comments-assesment/EXCELENTE.svg';
            }

          }

          getComments(): void {

            const params = `/cruds/comments/by-product/${this.productId}?booking_agency_id=${this.userService?._agencyID}&booking_agent_id=${this.userService?._agentID}&client_id=${this.clientSetting.id}`;
            this.restService.doGet('api', params).subscribe({
              next: (res: any) => {
                  this.comments = res.list;
                  this.commentsAgent = res.edits;

                    if(
                        this.action === 'comments' &&
                        !this.commentsAgentsCreateValid()
                      ) {
                          console.warn('Ya ha creado para este producto');
                        }
              },
              error: (error: HttpErrorResponse) => {
                console.log(error);
              }
            })
          }

          editComments(): void {
            this.editCommentsVisible = !this.editCommentsVisible;

            this.formCommentVisible = !this.formCommentVisible;

            this.commentsForm.patchValue({
                 comments: this.commentsAgent[0]?.comments,
                 title: this.commentsAgent[0]?.title,
                 assesment: this.commentsAgent[0]?.assesment,
                 assent: this.commentsAgent[0]?.assent,
                 reservation_date: this.commentsAgent[0]?.reservation_date,
                 passenger_name: this.commentsAgent[0]?.passenger_name
            });
          }

          commentsAgentsCreateValid(): boolean {

            if(this.commentsAgent.length === 0) {
              return true;
            }
            if(
                this.commentsAgent &&
                this.commentsAgent.length > 0
              ) {
                  return this.commentsAgent[0]?.create_status === 1
                }
          }

          commentsAgentsUpdateValid(): boolean {

            if(this.commentsAgent.length === 0) {
              return false;
            }
            if(
                this.commentsAgent &&
                this.commentsAgent.length > 0
              ) {
                  return this.commentsAgent[0]?.comment_enabled === '1'
                }
          }

          fixCalendarPosition(): void {
  setTimeout(() => {
    const input = document.getElementById('reservation_date');
    const calendar = document.querySelector('bs-datepicker-container') as HTMLElement;

    if (input && calendar) {
      const rect = input.getBoundingClientRect();
      calendar.style.position = 'fixed';
      calendar.style.top = `${rect.bottom + 5}px`;
      calendar.style.left = `${rect.left}px`;
      calendar.style.zIndex = '1060';
    }
  }, 0); // Puede ser 0 si usás onShown
}

  // getSafeUrl(url:string){
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }

  toggleTextComplete() {
    this.textComplete = !this.textComplete;
  }

  getStyleContainerIcons(index: number, assesment: number): any {
    return {
      'background-color': index < assesment ? this.colors[assesment - 1] : 'transparent',
      'margin-left': index > 0 ? '2px' : '',
      'width': '18px',
      'height': '18px',
      'border-radius': '50%',
      'position': 'relative',
      'z-index': 1,
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'center'
    }
  }
}
